module.exports = __webpack_public_path__ + "d44f1bd70936090c57f18985728976ae.pdf";